import React from 'react';
import styles from './paymentusagedetaiheader.module.scss';
import { useTranslation } from 'react-i18next';

const PaymentUsageDetailHeader = () => {
  // translations
  const tLabels = useTranslation("payments\\payments").t;

  return (
    <div className="d-none d-sm-block mb-2 text-muted font-weight-bold">
      <div className="row no-gutters px-2 px-sm-3">
        <div className="col">
          <div className="row no-gutters">
            <div className="col-sm-7 col-lg-8">
              <div className="row no-gutters align-items-center">
                <div className="col-sm-7 col-lg-5">
                  {tLabels("paymentUsageDetailHeader.usedFor")}               
                </div>
              <div className="col-sm-5 col-lg-7">
                <div className="row no-gutters align-items-lg-center ">
                  <div className="col-lg-6">
                    <span className="d-lg-none">{tLabels("paymentUsageDetailHeader.numberDueDate")}</span>
                    <span className="d-none d-lg-inline">{tLabels("paymentUsageDetailHeader.invoiceNumber")}</span>
                  </div>
                  <div className="d-none d-lg-block col-lg-6">
                    {tLabels("paymentUsageDetailHeader.dueDate")}
                  </div>
                </div>
              </div>
              </div>
            </div>
            <div className="col-sm-5 col-lg-4">
              <div className="row no-gutters">
                <div className="col-sm-6">
                  {tLabels("paymentUsageDetailHeader.payment")}
                </div>
                <div className="col-sm-6 text-nowrap">
                  {tLabels("paymentUsageDetailHeader.paymentDocument")}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className={`col-auto ${styles.btnCol}`}>
        </div>
      </div>
    </div>
  );
}

export default PaymentUsageDetailHeader;
